package com.iregained.eventapp.pages

import androidx.compose.runtime.*
import com.iregained.eventapp.components.layouts.AdminLayout
import com.iregained.eventapp.components.models.StaffProfile
import com.iregained.eventapp.components.sections.admin_dashboard.sections.LiveQueueSection
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.firestore.firestore

@Page("/admin/dashboard")
@Composable
fun AdminDashboardPage() {
    val ctx = rememberPageContext()

    var currentUserProfile by remember { mutableStateOf<StaffProfile?>(null) }
    var isLoading by remember { mutableStateOf(true) }

    LaunchedEffect(Unit) {
        val authUser = Firebase.auth.currentUser
        if (authUser == null) {
            ctx.router.navigateTo("/admin/login")
            return@LaunchedEffect
        }
        try {
            val db = Firebase.firestore
            val profileDoc = db.collection("staff").document(authUser.uid).get()
            if (profileDoc.exists) {
                currentUserProfile = profileDoc.data<StaffProfile>()
                db.collection("presence").document(authUser.uid).set(
                    mapOf("staffName" to currentUserProfile!!.fullName, "activeModule" to "IDLE"), merge = true
                )
            }
        } catch (e: Exception) {
            console.error(e)
        } finally {
            isLoading = false
        }
    }

    if (isLoading) {
        Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) { SpanText("Loading...") }
        return
    }

    // Compose the Layout and Section together
    AdminLayout(staffName = currentUserProfile?.fullName ?: "Staff") {
        LiveQueueSection()
    }
}